import {
  AlertTriangle,
  ArrowRight,
  Briefcase,
  Check,
  ChevronLeft,
  ChevronRight,
  CircuitBoardIcon,
  Command,
  CreditCard,
  File,
  FileText,
  HelpCircle,
  Image,
  Laptop,
  LayoutDashboardIcon,
  Loader2,
  LogIn,
  type LucideIcon,
  type LucideProps,
  LucideShoppingBag,
  Moon,
  MoreVertical,
  Pizza,
  Plus,
  Settings,
  SunMedium,
  Trash,
  Twitter,
  User,
  UserCircle2Icon,
  UserPen,
  UserX2Icon,
  X,
  MapPinned,
  Building,
  SendHorizontal,
  Database,
  FolderCheck,
  FolderCog,
  MessageSquare
} from 'lucide-react';

export type Icon = LucideIcon;

export const Icons = {
  dashboard: LayoutDashboardIcon,
  logo: Command,
  login: LogIn,
  close: X,
  product: LucideShoppingBag,
  spinner: Loader2,
  kanban: CircuitBoardIcon,
  chevronLeft: ChevronLeft,
  chevronRight: ChevronRight,
  trash: Trash,
  employee: UserX2Icon,
  post: FileText,
  page: File,
  userPen: UserPen,
  user2: UserCircle2Icon,
  media: Image,
  settings: Settings,
  billing: CreditCard,
  ellipsis: MoreVertical,
  add: Plus,
  warning: AlertTriangle,
  user: User,
  arrowRight: ArrowRight,
  help: HelpCircle,
  pizza: Pizza,
  sun: SunMedium,
  moon: Moon,
  laptop: Laptop,
  mapPin: MapPinned,
  building: Building,
  send: SendHorizontal,
  data: Database,
  folderCheck: FolderCheck,
  folderCog: FolderCog,
  messageSquare: MessageSquare,
  briefcase: Briefcase,
  gitHub: ({ ...props }: LucideProps) => (
    <svg
      aria-hidden='true'
      focusable='false'
      data-prefix='fab'
      data-icon='github'
      role='img'
      xmlns='http://www.w3.org/2000/svg'
      viewBox='0 0 496 512'
      {...props}
    >
      <path
        fill='currentColor'
        d='M165.9 397.4c0 2-2.3 3.6-5.2 3.6-3.3 .3-5.6-1.3-5.6-3.6 0-2 2.3-3.6 5.2-3.6 3-.3 5.6 1.3 5.6 3.6zm-31.1-4.5c-.7 2 1.3 4.3 4.3 4.9 2.6 1 5.6 0 6.2-2s-1.3-4.3-4.3-5.2c-2.6-.7-5.5 .3-6.2 2.3zm44.2-1.7c-2.9 .7-4.9 2.6-4.6 4.9 .3 2 2.9 3.3 5.9 2.6 2.9-.7 4.9-2.6 4.6-4.6-.3-1.9-3-3.2-5.9-2.9zM244.8 8C106.1 8 0 113.3 0 252c0 110.9 69.8 205.8 169.5 239.2 12.8 2.3 17.3-5.6 17.3-12.1 0-6.2-.3-40.4-.3-61.4 0 0-70 15-84.7-29.8 0 0-11.4-29.1-27.8-36.6 0 0-22.9-15.7 1.6-15.4 0 0 24.9 2 38.6 25.8 21.9 38.6 58.6 27.5 72.9 20.9 2.3-16 8.8-27.1 16-33.7-55.9-6.2-112.3-14.3-112.3-110.5 0-27.5 7.6-41.3 23.6-58.9-2.6-6.5-11.1-33.3 2.6-67.9 20.9-6.5 69 27 69 27 20-5.6 41.5-8.5 62.8-8.5s42.8 2.9 62.8 8.5c0 0 48.1-33.6 69-27 13.7 34.7 5.2 61.4 2.6 67.9 16 17.7 25.8 31.5 25.8 58.9 0 96.5-58.9 104.2-114.8 110.5 9.2 7.9 17 22.9 17 46.4 0 33.7-.3 75.4-.3 83.6 0 6.5 4.6 14.4 17.3 12.1C428.2 457.8 496 362.9 496 252 496 113.3 383.5 8 244.8 8zM97.2 352.9c-1.3 1-1 3.3 .7 5.2 1.6 1.6 3.9 2.3 5.2 1 1.3-1 1-3.3-.7-5.2-1.6-1.6-3.9-2.3-5.2-1zm-10.8-8.1c-.7 1.3 .3 2.9 2.3 3.9 1.6 1 3.6 .7 4.3-.7 .7-1.3-.3-2.9-2.3-3.9-2-.6-3.6-.3-4.3 .7zm32.4 35.6c-1.6 1.3-1 4.3 1.3 6.2 2.3 2.3 5.2 2.6 6.5 1 1.3-1.3 .7-4.3-1.3-6.2-2.2-2.3-5.2-2.6-6.5-1zm-11.4-14.7c-1.6 1-1.6 3.6 0 5.9 1.6 2.3 4.3 3.3 5.6 2.3 1.6-1.3 1.6-3.9 0-6.2-1.4-2.3-4-3.3-5.6-2z'
      ></path>
    </svg>
  ),
  customUpload: ({ ...props }: LucideProps) => (
    <svg
      width='16'
      height='16'
      viewBox='0 0 16 16'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      {...props}
    >
      <path
        d='M1.33594 8.66667C1.33594 8.33333 1.66927 8 2.0026 8C2.33594 8 2.66927 8.33333 2.66927 8.66667C2.66927 9 2.66927 12 2.66927 12C2.66927 12.7364 3.26622 13.3333 4.0026 13.3333H12.0026C12.739 13.3333 13.3359 12.7364 13.3359 12V8.66667C13.3359 8.29848 13.6344 8 14.0026 8C14.3708 8 14.6693 8.29848 14.6693 8.66667V12C14.6693 13.4728 13.4754 14.6667 12.0026 14.6667H4.0026C2.52984 14.6667 1.33594 13.4728 1.33594 12C1.33594 12 1.33594 9 1.33594 8.66667Z'
        fill='#1B3C8E'
      />
      <rect
        opacity='0.3'
        x='7.33594'
        y='1.33301'
        width='1.33333'
        height='9.33333'
        rx='0.666667'
        fill='#1B3C8E'
      />
      <path
        d='M8.02416 2.25231L5.13807 5.1384C4.87772 5.39875 4.45561 5.39875 4.19526 5.1384C3.93491 4.87805 3.93491 4.45594 4.19526 4.19559L7.5286 0.862256C7.77932 0.611534 8.18242 0.600934 8.44598 0.838131L11.7793 3.83813C12.053 4.08444 12.0752 4.50596 11.8289 4.77964C11.5826 5.05331 11.161 5.0755 10.8874 4.82919L8.02416 2.25231Z'
        fill='#1B3C8E'
      />
    </svg>
  ),
  customFile: () => (
    <svg
      width='73'
      height='74'
      viewBox='0 0 73 74'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        d='M60.5 63.8369C60.5 65.7699 58.933 67.3369 57 67.3369H16C14.067 67.3369 12.5 65.7699 12.5 63.8369V7.98926C12.5 6.05626 14.067 4.48926 16 4.48926H44.0527C44.9795 4.48926 45.8685 4.85684 46.5246 5.51139L59.4719 18.4274C60.1301 19.084 60.5 19.9755 60.5 20.9052V63.8369Z'
        fill='#C8EBFE'
      />
      <path
        d='M21.875 28.0566H47.375V31.0494H21.875V28.0566ZM21.875 34.0421H41.375V37.0349H21.875V34.0421ZM21.875 40.0276H47.375V43.0204H21.875V40.0276ZM21.875 46.0131H41.375V49.0059H21.875V46.0131Z'
        fill='white'
      />
      <rect
        x='45.5'
        y='51.1738'
        width='22.5'
        height='22.826'
        rx='11.25'
        fill='#2658AB'
      />
      <path
        d='M56.75 59.5244V65.6494'
        stroke='white'
        strokeWidth='1.3125'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M53.6875 62.5869H59.8125'
        stroke='white'
        strokeWidth='1.3125'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
    </svg>
  ),
  customFlash: ({ ...props }: LucideProps) => (
    <svg
      width='24'
      height='24'
      viewBox='0 0 24 24'
      fill='currentColor'
      xmlns='http://www.w3.org/2000/svg'
      {...props}
    >
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M15 19.5229C15 20.265 15.9624 20.5564 16.374 19.9389L22.2227 11.166C22.5549 10.6676 22.1976 10 21.5986 10H17V4.47708C17 3.73503 16.0376 3.44363 15.626 4.06106L9.77735 12.834C9.44507 13.3324 9.80237 14 10.4014 14H15V19.5229Z'
        fill=''
      />
      <path
        opacity='0.3'
        fillRule='evenodd'
        clipRule='evenodd'
        d='M3 6.5C3 5.67157 3.67157 5 4.5 5H9.5C10.3284 5 11 5.67157 11 6.5C11 7.32843 10.3284 8 9.5 8H4.5C3.67157 8 3 7.32843 3 6.5ZM3 18.5C3 17.6716 3.67157 17 4.5 17H9.5C10.3284 17 11 17.6716 11 18.5C11 19.3284 10.3284 20 9.5 20H4.5C3.67157 20 3 19.3284 3 18.5ZM2.5 11C1.67157 11 1 11.6716 1 12.5C1 13.3284 1.67157 14 2.5 14H6.5C7.32843 14 8 13.3284 8 12.5C8 11.6716 7.32843 11 6.5 11H2.5Z'
        fill=''
      />
    </svg>
  ),
  verified: ({ ...props }: LucideProps) => (
    <svg
      width='16'
      height='16'
      viewBox='0 0 16 16'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      {...props}
    >
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M8.0026 14.6663C11.6845 14.6663 14.6693 11.6816 14.6693 7.99967C14.6693 4.31778 11.6845 1.33301 8.0026 1.33301C4.32071 1.33301 1.33594 4.31778 1.33594 7.99967C1.33594 11.6816 4.32071 14.6663 8.0026 14.6663Z'
        fill='#2658AB'
      />
      <path
        d='M10.1691 5.1672C10.35 4.9547 10.6537 4.94322 10.8475 5.14155C11.0413 5.33989 11.0518 5.67293 10.8709 5.88543L7.51091 9.83279C7.33542 10.039 7.04291 10.0568 6.84763 9.87329L5.16763 8.29434C4.96635 8.10517 4.94304 7.77291 5.11557 7.55221C5.28809 7.33152 5.59111 7.30596 5.79239 7.49513L7.12304 8.74574L10.1691 5.1672Z'
        fill='#F2FBFF'
      />
    </svg>
  ),
  linkedIn: ({ ...props }: LucideProps) => (
    <svg
      width='18'
      height='18'
      viewBox='0 0 18 18'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      {...props}
    >
      <path
        d='M16.0604 0.667109H1.94375C1.78507 0.664905 1.6275 0.693982 1.48005 0.752679C1.33261 0.811375 1.19817 0.898543 1.08441 1.0092C0.97066 1.11986 0.879818 1.25185 0.817077 1.39762C0.754335 1.54339 0.720924 1.70009 0.71875 1.85878V16.1421C0.720924 16.3008 0.754335 16.4575 0.817077 16.6033C0.879818 16.749 0.97066 16.881 1.08441 16.9917C1.19817 17.1023 1.33261 17.1895 1.48005 17.2482C1.6275 17.3069 1.78507 17.336 1.94375 17.3338H16.0604C16.2191 17.336 16.3767 17.3069 16.5241 17.2482C16.6716 17.1895 16.806 17.1023 16.9198 16.9917C17.0335 16.881 17.1243 16.749 17.1871 16.6033C17.2498 16.4575 17.2832 16.3008 17.2854 16.1421V1.85878C17.2832 1.70009 17.2498 1.54339 17.1871 1.39762C17.1243 1.25185 17.0335 1.11986 16.9198 1.0092C16.806 0.898543 16.6716 0.811375 16.5241 0.752679C16.3767 0.693982 16.2191 0.664905 16.0604 0.667109ZM5.74375 14.6171H3.24375V7.11711H5.74375V14.6171ZM4.49375 6.06711C4.14897 6.06711 3.81831 5.93014 3.57451 5.68635C3.33071 5.44255 3.19375 5.11189 3.19375 4.76711C3.19375 4.42233 3.33071 4.09167 3.57451 3.84787C3.81831 3.60407 4.14897 3.46711 4.49375 3.46711C4.67683 3.44635 4.86223 3.46449 5.03781 3.52034C5.21339 3.5762 5.3752 3.66852 5.51263 3.79124C5.65006 3.91397 5.76002 4.06434 5.83531 4.23251C5.9106 4.40068 5.94951 4.58286 5.94951 4.76711C5.94951 4.95136 5.9106 5.13354 5.83531 5.30171C5.76002 5.46988 5.65006 5.62025 5.51263 5.74297C5.3752 5.8657 5.21339 5.95801 5.03781 6.01387C4.86223 6.06973 4.67683 6.08787 4.49375 6.06711ZM14.7604 14.6171H12.2604V10.5921C12.2604 9.58378 11.9021 8.92544 10.9937 8.92544C10.7126 8.9275 10.4389 9.01568 10.2094 9.17809C9.97999 9.3405 9.80582 9.56934 9.71042 9.83378C9.6452 10.0296 9.61695 10.2359 9.62708 10.4421V14.6088H7.12708C7.12708 14.6088 7.12708 7.79211 7.12708 7.10878H9.62708V8.16711C9.85419 7.77303 10.1845 7.44838 10.5825 7.22811C10.9804 7.00785 11.4309 6.90032 11.8854 6.91711C13.5521 6.91711 14.7604 7.99211 14.7604 10.3004V14.6171Z'
        fill='#1B3C8E'
      />
    </svg>
  ),
  emptyState: ({ ...props }: LucideProps) => (
    <svg
      width='128'
      height='135'
      viewBox='0 0 128 135'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      {...props}
    >
      <path
        d='M70.3016 109.7C98.3016 109.7 121.002 86.9996 121.002 58.8996C121.002 30.7996 98.2016 8.09961 70.3016 8.09961C42.3016 8.09961 19.6016 30.7996 19.6016 58.8996C19.6016 86.9996 42.3016 109.7 70.3016 109.7Z'
        fill='#EAEEF9'
      />
      <path
        d='M117.702 25.6004C119.966 25.6004 121.802 23.7648 121.802 21.5004C121.802 19.236 119.966 17.4004 117.702 17.4004C115.437 17.4004 113.602 19.236 113.602 21.5004C113.602 23.7648 115.437 25.6004 117.702 25.6004Z'
        fill='#EAEEF9'
      />
      <path
        d='M123.698 9.6C125.245 9.6 126.498 8.3464 126.498 6.8C126.498 5.2536 125.245 4 123.698 4C122.152 4 120.898 5.2536 120.898 6.8C120.898 8.3464 122.152 9.6 123.698 9.6Z'
        fill='#EAEEF9'
      />
      <path
        d='M22.3 25.5004C23.8464 25.5004 25.1 24.2468 25.1 22.7004C25.1 21.154 23.8464 19.9004 22.3 19.9004C20.7536 19.9004 19.5 21.154 19.5 22.7004C19.5 24.2468 20.7536 25.5004 22.3 25.5004Z'
        fill='#EAEEF9'
      />
      <path
        d='M5.2 79.4996C8.07188 79.4996 10.4 77.1715 10.4 74.2996C10.4 71.4277 8.07188 69.0996 5.2 69.0996C2.32812 69.0996 0 71.4277 0 74.2996C0 77.1715 2.32812 79.4996 5.2 79.4996Z'
        fill='#EAEEF9'
      />
      <g filter='url(#filter0_d_4925_41770)'>
        <path
          d='M104.797 33.4992L105.597 97.8992C105.597 100.099 103.797 101.799 101.597 101.799H38.7969C36.5969 101.799 34.7969 99.9992 34.7969 97.8992V15.0992C34.7969 12.8992 36.5969 11.1992 38.7969 11.1992H84.2969L104.797 33.4992Z'
          fill='url(#paint0_linear_4925_41770)'
        />
      </g>
      <path
        d='M65.4031 88.8992H53.1031C52.6031 88.8992 52.2031 88.3992 52.2031 87.7992C52.2031 87.1992 52.6031 86.6992 53.1031 86.6992H65.4031C65.9031 86.6992 66.3031 87.1992 66.3031 87.7992C66.3031 88.4992 65.9031 88.8992 65.4031 88.8992Z'
        fill='#D5DDEA'
      />
      <path
        d='M58.4016 88.8992H45.0016C44.5016 88.8992 44.1016 88.3992 44.1016 87.7992C44.1016 87.1992 44.5016 86.6992 45.0016 86.6992H58.4016C58.9016 86.6992 59.3016 87.1992 59.3016 87.7992C59.3016 88.4992 58.9016 88.8992 58.4016 88.8992Z'
        fill='#D5DDEA'
      />
      <path
        d='M75.5016 24.6996H45.4016C44.7016 24.6996 44.1016 24.0996 44.1016 23.3996C44.1016 22.6996 44.7016 22.0996 45.4016 22.0996H75.5016C76.2016 22.0996 76.8016 22.6996 76.8016 23.3996C76.8016 24.0996 76.2016 24.6996 75.5016 24.6996Z'
        fill='#D5DDEA'
      />
      <path
        d='M57.0016 31.9008H45.4016C44.7016 31.9008 44.1016 31.3008 44.1016 30.6008C44.1016 29.9008 44.7016 29.3008 45.4016 29.3008H56.9016C57.6016 29.3008 58.2016 29.9008 58.2016 30.6008C58.2016 31.3008 57.6016 31.9008 57.0016 31.9008Z'
        fill='#D5DDEA'
      />
      <path
        d='M84.2969 11.1992V28.9992C84.2969 31.4992 86.4969 33.4992 88.9969 33.4992H104.797'
        fill='#D5DDEA'
      />
      <defs>
        <filter
          id='filter0_d_4925_41770'
          x='12.7969'
          y='0.199219'
          width='114.797'
          height='134.6'
          filterUnits='userSpaceOnUse'
          colorInterpolationFilters='sRGB'
        >
          <feFlood floodOpacity='0' result='BackgroundImageFix' />
          <feColorMatrix
            in='SourceAlpha'
            type='matrix'
            values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0'
            result='hardAlpha'
          />
          <feOffset dy='11' />
          <feGaussianBlur stdDeviation='11' />
          <feColorMatrix
            type='matrix'
            values='0 0 0 0 0.397708 0 0 0 0 0.47749 0 0 0 0 0.575 0 0 0 0.27 0'
          />
          <feBlend
            mode='normal'
            in2='BackgroundImageFix'
            result='effect1_dropShadow_4925_41770'
          />
          <feBlend
            mode='normal'
            in='SourceGraphic'
            in2='effect1_dropShadow_4925_41770'
            result='shape'
          />
        </filter>
        <linearGradient
          id='paint0_linear_4925_41770'
          x1='70.1738'
          y1='9.10355'
          x2='70.1738'
          y2='102.776'
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='#FDFEFF' />
          <stop offset='0.9964' stopColor='#ECF0F5' />
        </linearGradient>
      </defs>
    </svg>
  ),
  rolodexLogo: ({ ...props }: LucideProps) => (
    <svg
      width='668'
      height='82'
      viewBox='0 0 668 82'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      {...props}
    >
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M23.039 41C23.039 42.0394 23.128 43.058 23.2988 44.0487C23.4339 44.8316 23.0036 45.6207 22.2467 45.8623L3.8294 51.7407C3.02014 51.999 2.15534 51.5349 1.95801 50.7087C1.23524 47.6824 0.852539 44.5241 0.852539 41.2764C0.852539 41.2542 0.852557 41.232 0.852593 41.2098C0.853893 40.4028 1.51918 39.7643 2.32617 39.7643H21.8445C22.5134 39.7643 23.039 40.3311 23.039 41ZM2.46709 29.924C2.19521 30.8558 2.911 31.7643 3.8816 31.7643L24.9264 31.7643C25.3553 31.7643 25.7508 31.538 25.9876 31.1804C26.3275 30.6668 26.2794 29.9796 25.84 29.548L11.9043 15.8617C11.2877 15.2561 10.2862 15.294 9.7451 15.9678C6.47064 20.0461 3.97031 24.7725 2.46709 29.924ZM17.9715 8.22673C17.229 8.75197 17.167 9.81732 17.8159 10.4546L31.9856 24.3707C32.4462 24.8231 33.142 24.924 33.7337 24.6658C35.914 23.7143 38.3216 23.1864 40.8525 23.1864C42.4064 23.1864 43.9137 23.3854 45.3505 23.7592C46.2441 23.9917 47.191 23.4655 47.3698 22.5597L51.1359 3.4844C51.29 2.70407 50.8088 1.93617 50.0319 1.7654C47.2219 1.14768 44.3024 0.822098 41.3069 0.822098C32.616 0.822098 24.5652 3.56266 17.9715 8.22673ZM81.732 42.8268C81.7632 41.9982 81.0885 41.3246 80.2594 41.3246H60.1366C59.3186 41.3246 58.6582 41.9814 58.5767 42.7953C58.1382 47.177 56.1119 51.0907 53.0816 53.9527C52.4402 54.5586 52.359 55.5783 52.9644 56.2202L66.7632 70.8492C67.3142 71.4334 68.2298 71.482 68.8185 70.9357C76.4268 63.8751 81.3139 53.9228 81.732 42.8268ZM59.446 77.446C60.3169 77.0084 60.4913 75.859 59.8225 75.1499L44.6908 59.1078C44.341 58.7369 43.8273 58.5737 43.3223 58.6437C42.5151 58.7557 41.6906 58.8136 40.8525 58.8136C40.4775 58.8136 40.1053 58.802 39.736 58.7791C39.1381 58.7422 38.5589 59.0272 38.2594 59.546L27.8436 77.5866C27.3814 78.3872 27.746 79.4131 28.6239 79.7027C32.6131 81.0187 36.8768 81.7307 41.3069 81.7307C47.8288 81.7307 53.9903 80.1874 59.446 77.446ZM18.4856 74.6838C19.1877 75.1644 20.1419 74.9264 20.5673 74.1895L30.4062 57.1482C30.8042 56.4588 30.5898 55.5836 29.9602 55.0965C29.2737 54.5653 28.6272 53.985 28.0257 53.361C27.6084 52.9282 26.986 52.7472 26.4132 52.93L6.95542 59.1406C6.07308 59.4222 5.65286 60.4295 6.11047 61.2347C9.16221 66.6049 13.4075 71.2082 18.4856 74.6838Z'
        fill='#2658AB'
      />
      <path
        d='M127.573 36.76H156.053V69.8H146.453L145.493 62.84C141.573 67.8 135.413 70.6 127.493 70.6C112.133 70.6 100.853 59.8 100.853 42.12C100.853 23.96 112.213 11.4 129.493 11.4C143.253 11.4 153.253 18.92 155.733 30.76H143.013C140.773 24.6 135.493 21.88 129.333 21.88C119.333 21.88 112.773 29.08 112.773 41.08C112.773 53 119.253 60.2 129.013 60.2C135.493 60.2 144.053 56.76 144.613 47L145.333 47.08V46.12H127.573V36.76Z'
        fill='#1F2937'
      />
      <path
        d='M175.829 59.72H204.629V69.8H164.389V12.2H203.669V22.28H175.829V35.96H196.949V45.8H175.829V59.72Z'
        fill='#1F2937'
      />
      <path
        d='M234.326 70.6C217.606 70.6 206.246 58.44 206.246 41.08C206.246 23.64 217.606 11.4 234.326 11.4C251.046 11.4 262.326 23.64 262.326 41.08C262.326 58.44 251.046 70.6 234.326 70.6ZM234.326 59.8C244.326 59.8 250.086 52.52 250.086 41.08C250.086 29.56 244.326 22.2 234.326 22.2C224.246 22.2 218.406 29.56 218.406 41.08C218.406 52.6 224.246 59.8 234.326 59.8Z'
        fill='#1F2937'
      />
      <path 
        d='M268.649 41H294.169V51.16H268.649V41Z' 
        fill='#1F2937'
      />
      <path
        d='M301.62 69.8V12.2H327.54C338.9 12.2 347.38 19.4 347.38 31C347.38 39.96 342.82 46.76 335.7 48.92L346.34 69.8H333.46L323.86 50.44H312.98V69.8H301.62ZM312.98 40.76H325.7C332.02 40.76 335.38 37.4 335.38 31.4C335.38 25.4 332.02 22.28 325.7 22.28H312.98V40.76Z'
        fill='#1F2937'
      />
      <path
        d='M379.839 70.6C363.119 70.6 351.759 58.44 351.759 41.08C351.759 23.64 363.119 11.4 379.839 11.4C396.559 11.4 407.839 23.64 407.839 41.08C407.839 58.44 396.559 70.6 379.839 70.6ZM379.839 59.8C389.839 59.8 395.599 52.52 395.599 41.08C395.599 29.56 389.839 22.2 379.839 22.2C369.759 22.2 363.919 29.56 363.919 41.08C363.919 52.6 369.759 59.8 379.839 59.8Z'
        fill='#1F2937'
      />
      <path
        d='M425.954 59.32H452.194V69.8H414.514V12.2H425.954V59.32Z'
        fill='#1F2937'
      />
      <path
        d='M480.545 70.6C463.825 70.6 452.465 58.44 452.465 41.08C452.465 23.64 463.825 11.4 480.545 11.4C497.265 11.4 508.545 23.64 508.545 41.08C508.545 58.44 497.265 70.6 480.545 70.6ZM480.545 59.8C490.545 59.8 496.305 52.52 496.305 41.08C496.305 29.56 490.545 22.2 480.545 22.2C470.465 22.2 464.625 29.56 464.625 41.08C464.625 52.6 470.465 59.8 480.545 59.8Z'
        fill='#1F2937'
      />
      <path
        d='M515.22 69.8V12.2H536.26C554.26 12.2 565.22 24.04 565.22 41C565.22 58.2 554.26 69.8 536.26 69.8H515.22ZM526.66 59.72H535.62C546.5 59.72 553.22 52.44 553.22 40.68C553.22 28.92 546.5 22.28 535.62 22.28H526.66V59.72Z'
        fill='#1F2937'
      />
      <path
        d='M583.263 59.72H612.063V69.8H571.823V12.2H611.103V22.28H583.263V35.96H604.383V45.8H583.263V59.72Z'
        fill='#1F2937'
      />
      <path
        d='M667.146 69.8H653.786L640.426 48.36L627.466 69.8H614.426L632.026 40.68L614.426 12.2H627.786L640.506 33.64L653.546 12.2H666.506L648.826 40.76L667.146 69.8Z'
        fill='#1F2937'
      />
    </svg>
  ),
  pvLogo: ({ ...props }: LucideProps) => (
    <svg
      width='200'
      height='27'
      viewBox='0 0 200 27'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      {...props}
    >
      <path
        d='M13.451 0.17627C7.27969 0.177008 1.96394 4.52706 0.742271 10.5763C-0.4794 16.6255 2.73154 22.6975 8.41891 25.0932V14.696L12.5126 12.3329V26.0722C12.823 26.0948 13.1352 26.1101 13.451 26.1101C20.6115 26.1101 26.4161 20.3054 26.4161 13.145C26.4161 5.98456 20.6115 0.179879 13.451 0.179879V0.17627ZM18.484 14.9965L14.3894 17.3596V10.9533L8.41891 7.50563V2.77398L18.4615 8.57215L18.484 8.58388V14.9965Z'
        fill='white'
      />
      <path
        d='M97.2002 4.69217C100.233 4.63121 103.077 6.15225 104.701 8.7034L102.581 10.2602C101.468 8.37334 99.4244 7.22517 97.2268 7.25143C93.6556 7.25143 90.7605 10.1344 90.7605 13.6906C90.7605 17.2469 93.6556 20.1298 97.2268 20.1298C99.4245 20.1563 101.468 19.0081 102.581 17.1211L104.701 18.6791C103.091 21.2445 100.237 22.7703 97.2002 22.6903C93.9269 22.7572 90.8732 21.0565 89.2169 18.2443C87.5605 15.4321 87.5605 11.9479 89.2169 9.13567C90.8732 6.32345 93.9269 4.62277 97.2002 4.68965V4.69217Z'
        fill='white'
      />
      <path
        d='M55.6317 4.69223C60.6059 4.7645 64.5865 8.82581 64.5383 13.7795C64.4901 18.7331 60.4312 22.7169 55.4565 22.6932C50.4818 22.6694 46.4615 18.6471 46.4609 13.6932C46.4686 11.2855 47.4415 8.98054 49.1635 7.29041C50.8855 5.60028 53.214 4.66495 55.6317 4.69223ZM55.6583 7.25275C53.0252 7.17819 50.6099 8.70164 49.5523 11.1041C48.4947 13.5065 49.0062 16.3077 50.8455 18.1855C52.6849 20.0633 55.4842 20.6423 57.9224 19.6493C60.3605 18.6563 61.9501 16.2898 61.9408 13.6667C62.0115 11.9724 61.3778 10.324 60.1888 9.10995C58.9999 7.89591 57.361 7.22488 55.6583 7.25275Z'
        fill='white'
      />
      <path
        d='M32.0645 4.97754H38.4522C41.9782 4.97754 44.3898 7.16812 44.3898 10.3094C44.3898 13.4242 41.9808 15.6678 38.4522 15.6678H34.8741V22.4012H32.0657L32.0645 4.97754ZM38.404 13.1843C39.4835 13.2658 40.518 12.7384 41.0828 11.8186C41.6476 10.8988 41.6476 9.74153 41.0828 8.82175C40.518 7.90196 39.4835 7.37455 38.404 7.45599H34.8779V13.1843H38.404Z'
        fill='white'
      />
      <path
        d='M68.1982 4.97754H71.0079V19.895H79.0122V22.4012H68.1982V4.97754Z'
        fill='white'
      />
      <path
        d='M81.8525 4.97754H84.6622V22.4012H81.8525V4.97754Z'
        fill='white'
      />
      <path
        d='M114.961 15.3826V22.4013H112.151V15.3826L106.108 4.98267H109.236L113.557 12.5582L117.904 4.98267H121.005L114.961 15.3826Z'
        fill='white'
      />
      <path
        d='M149.772 20.9726H143.489L142.855 22.4245H137.952L145.903 4.68774H147.361L155.312 22.4245H150.408L149.772 20.9726ZM146.644 13.2923L145.107 17.3325H148.15L146.644 13.2923Z'
        fill='white'
      />
      <path
        d='M139.96 4.99683L132.009 22.7336H130.556L122.599 4.99683H127.768L131.293 13.5483L134.792 4.99683H139.96Z'
        fill='white'
      />
      <path
        d='M156.347 4.99683H160.911V15.369C160.911 17.1185 162.335 18.5368 164.092 18.5368C165.849 18.5368 167.274 17.1185 167.274 15.369V4.99683H171.838V15.0268C171.838 19.2832 168.373 22.7336 164.099 22.7336C159.824 22.7336 156.359 19.2832 156.359 15.0268L156.347 4.99683Z'
        fill='white'
      />
      <path
        d='M175.222 4.99683H179.786V18.331H187.023V22.4205H175.232L175.222 4.99683Z'
        fill='white'
      />
      <path
        d='M189.855 9.09265H184.607V4.99683H199.666V9.0876H194.418V22.4205H189.854L189.855 9.09265Z'
        fill='white'
      />
    </svg>
  ),
  gatesLogo: ({ ...props }: LucideProps) => (
    <svg
      width='83'
      height='30'
      viewBox='0 0 83 30'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      xlinkHref='http://www.w3.org/1999/xlink'
      {...props}
    >
      <rect
        y='0.625'
        width='82.0133'
        height='29.0356'
        fill='url(#pattern0_538_2667)'
      />
      <defs>
        <pattern
          id='pattern0_538_2667'
          patternContentUnits='objectBoundingBox'
          width='1'
          height='1'
        >
          <use
            xlinkHref='#image0_538_2667'
            transform='matrix(0.00542197 0 0 0.0153148 -0.188441 -0.172184)'
          />
        </pattern>
        <image
          id='image0_538_2667'
          width='256'
          height='88'
          preserveAspectRatio='none'
          xlinkHref='data:image/png;base64,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'
        />
      </defs>
    </svg>
  ),
  twitter: Twitter,
  check: Check
};
